import { useState } from "react";
import { motion } from "framer-motion";
import AnimatedSection from "@/components/common/AnimatedSection";
import LightboxModal from "@/components/common/LightboxModal";
import PageHero from "@/components/common/PageHero";
import PageTransition from "@/components/layout/PageTransition";
import f from "../assets/1.jpg";
import s from "../assets/2.jpg";
import t from "../assets/3.jpg";
import fo from "../assets/4.jpg";
import fi from "../assets/7.jpg";
import si from "../assets/6.jpg";
import header from "../assets/4.jpg";

const galleryImages = [
  {
    title: "Exterior Facade",
    image: f,
  },
  {
    title: "Interior Facade",
    image: s
  },
  {
    title: "Comfortable Patient Area",
    image: t
  },
  {
    title: "Comfortable Patient Area",
    image: fo
  },
  {
    title: "Precision Treatment Workflow",
    image: fi
  },
  {
    title: "Advance Dental Setup",
    image: si
  },
];

export default function GalleryPage() {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <PageTransition testId="gallery-page">
      <div className={selectedImage ? "blur-[1px]" : ""}>
        <PageHero
          title="Clinic Gallery"
          subtitle="A visual glimpse into our premium care environment and advanced treatment ecosystem."
          image={header}
          testId="gallery-page-hero"
        />

        <div className="mx-auto max-w-7xl px-6 py-16 md:px-10 md:py-24">
          <AnimatedSection testId="gallery-grid-section">
            <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {galleryImages.map((item, index) => (
                <motion.button
                  key={item.title}
                  onClick={() => setSelectedImage(item)}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.45, delay: index * 0.04 }}
                  className="group overflow-hidden rounded-2xl border border-[#f2e6c9] bg-white text-left"
                  data-testid={`gallery-image-card-${item.title
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                >
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                      data-testid={`gallery-image-${item.title
                        .toLowerCase()
                        .replace(/\s+/g, "-")}`}
                    />
                  </div>
                  <p
                    className="px-4 py-3 font-[Manrope] text-sm text-[#333333]"
                    data-testid={`gallery-image-title-${item.title
                      .toLowerCase()
                      .replace(/\s+/g, "-")}`}
                  >
                    {item.title}
                  </p>
                </motion.button>
              ))}
            </div>
          </AnimatedSection>
        </div>
      </div>

      <LightboxModal
        isOpen={Boolean(selectedImage)}
        image={selectedImage?.image}
        title={selectedImage?.title}
        onClose={() => setSelectedImage(null)}
      />
    </PageTransition>
  );
}
